import { identity, path } from 'ramda';
import { createSelector } from 'reselect';

const targetPagePath = path(['appContext', 'targetPage']);

export const getTargetPage = createSelector(targetPagePath, identity);
